import styled from 'styled-components';

export const Avatar = styled.div`
  width: ${props => props.size || 36}px;
  height: ${props => props.size || 36}px;
  background: gray;
  border-radius: 50%;
  background-image: url(${props => props.src});
  background-position: center center;
  background-size: cover;
`;
